// import React, {PropsWithChildren} from 'react';

// import DropShadow from 'react-native-drop-shadow';

// import {colors} from 'asset/constant';

// export default function Shadow(props: PropsWithChildren<ShadowT>) {
//   const {
//     radius = 5,
//     opacity = 0.2,
//     color = colors.black,
//     offset = {x: 0, y: 0},
//   } = props;

//   return (
//     <DropShadow
//       style={{
//         shadowColor: color,
//         shadowRadius: radius,
//         shadowOpacity: opacity,
//         shadowOffset: {width: offset.x, height: offset.y},
//       }}
//       {...props}
//     />
//   );
// }

import { colors } from "asset/constant";
import React, { PropsWithChildren } from "react";
import { Platform, StyleSheet, View, ViewStyle } from "react-native";
import DropShadow from "react-native-drop-shadow";

const init: ShadowT = {
  offset: { x: 0, y: 0 },
  color: "#222",
  radius: 7,
  opacity: 0.5,
};

interface Props {
  shadow?: ShadowT;
  style?: ViewStyle;
}

const Shadow: React.FC<PropsWithChildren<Props>> = ({ shadow, ...props }) => {
  const styles = StyleSheet.create({
    shadowView: {
      shadowOffset: {
        width: 0,
        // width: shadow?.offset?.x ?? init?.offset?.x,
        height: 0,
        // height: shadow?.offset?.y ?? init?.offset?.y,
      },
      shadowColor: shadow?.color ?? init.color,
      shadowOpacity: shadow?.opacity ?? init.opacity,
      shadowRadius: shadow?.radius ?? init.radius,
    },
  });

  if (Platform.OS === "web") {
    return (
      <DropShadow style={{ ...styles.shadowView, ...props.style }}>
        {props.children}
      </DropShadow>
    );
  }

  return (
    <DropShadow style={styles.shadowView}>
      <View style={{ ...props.style }}>{props.children}</View>
    </DropShadow>
  );
};

export default Shadow;
